/**
 * XML sitemap endpoint page.
 * This route renders XML content at /sitemap.xml.
 */

import { useEffect, useState } from 'react';
import { generateSitemap } from '@/lib/seoManager';

export const SitemapXmlPage = () => {
  const [content, setContent] = useState<string>('');

  useEffect(() => {
    generateSitemap().then((xml) => {
      setContent(xml);
    });
  }, []);

  return <pre className="whitespace-pre-wrap font-mono p-5">{content}</pre>;
};

export default SitemapXmlPage;
